<template>
    <Sheet data-component="CartPreviewModalSheet"
           class="today-view-cart-preview-modal"
           size="sm"
           icon="fa-solid fa-sliders"
           :cancel="cancel"
           title="CART_PREVIEW.MODAL_TITLE">
        <div v-if="!currentCartHasLines"
             class="cart-preview__empty">
            {{ l('CART_PREVIEW.NO_ITEMS') }}
        </div>
        <div v-else>
            <template v-for="cartItemGroup in cartItemGroups"
                      :key="cartItemGroup.key">
                <OrderPreviewLineGroup v-if="cartItemGroup.session"
                                       :cart-item-group="cartItemGroup"
                                       :show-add-group-ref="showAddGroupRef" />
                <OrderPreviewLines v-else
                                   :lines="cartItemGroup.items" />
            </template>
        </div>

        <template v-slot:footer>
            <div class="sheet-footer">
                <SquareBtn size="lg"
                           class="cancel-btn"
                           color="white"
                           @click="cancel">
                    {{ l('CANCEL') }}
                </SquareBtn>

                <SquareBtn v-if="currentCartHasLines"
                           :loading="clearingCart"
                           size="lg"
                           color="white"
                           class="clear-btn"
                           @click="emptyCart">
                    {{ l('CART_PREVIEW.CLEAR_CART') }}
                </SquareBtn>

                <!-- Push the Clear button over to the left to mirror the design of the Filter sheet -->
                <span class="flex--grow desktop-only"></span>

                <SquareBtn size="lg"
                           color="info"
                           class="view-cart-btn"
                           @click="viewFullCart">
                    {{ l('CART_PREVIEW.VIEW_FULL_CART') }}
                </SquareBtn>
            </div>
        </template>
    </Sheet>
</template>

<script>
import OrderPreviewLineGroup from '@/epos/vue/modals/OrderPreview/OrderPreviewLineGroup';
import OrderPreviewLines from '@/epos/vue/modals/OrderPreview/OrderPreviewLines';
import Sheet from '@/vue/components/Modals/Sheet';
import SquareBtn from '@/vue/components/SquareBtn';
import { cloneDeep } from '@/functions/clone';
import { container } from '@/container';
import { mapState } from 'vuex';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';
import { timeoutPromise } from '@/functions/functions';

export default {
    name: 'CartPreviewModalSheet',

    components: {
        OrderPreviewLineGroup,
        OrderPreviewLines,
        Sheet,
        SquareBtn,
    },

    mixins: [
        ModalPropsMixin,
    ],

    data() {
        return {
            clearingCart: false,

            timeoutPeriod: 500,

            /**
             * This is updated by the cart modified watcher.
             *
             * @type {CartItemGroup[]}
             */
            cartItemGroups: [],

            showAddGroupRef: false,
        };
    },

    computed: {
        ...mapState('cart', ['currentCartHasLines']),
    },

    watch: {
        '$store.state.cart.modified': {
            handler() {
                this.cartItemGroups = cloneDeep(container.cartService.cartItemGroups);

                this.showAddGroupRef = container.currentDevice.device.manageGroupBookings
                    && container.cartService.currentCart.groupBooking;
            },
            immediate: true,
        },
    },

    methods: {
        viewFullCart() {
            this.cancel();
            container.navigationService.viewSell();
        },

        async emptyCart() {
            container.dialogService
                .confirm('CART_PREVIEW.CONFIRM_CLEAR_CART')
                .then(async (confirmed) => {
                    if (confirmed) {
                        this.clearingCart = true;
                        // A little pause makes it feel like something is happening.
                        await timeoutPromise(this.timeoutPeriod);
                        await container.cartService.clear();
                        this.clearingCart = false;
                    }
                    // The user cancelled
                    return null;
                });
        },
    },
};
</script>

<style lang="less" scoped>
@import "../../../../less/variables";
.view-cart-btn {
    min-width: 150px;
}
.cart-preview__empty {
    text-align: center;
}
</style>
